import { isPending } from "q"

interface ConfirmModalProps {
    text: string
    description: string
    confirmText: string
    onConfirm: () => void
    closeModal: () => void
    isPending?: boolean
    cancelText?: string
}

const ConfirmModal = ({text, description, confirmText, onConfirm, closeModal, isPending, cancelText}: ConfirmModalProps) => {
    const handleCancelComplete = () => {
        closeModal()
    }

    return (
        <div className="manageEventModal__confirmOverlay">
            <div className="manageEventModal__confirm">
                <h2>{text}</h2>
                <p>{description}</p>
                <div className="manageEventModal__confirmActions">
                    <button
                        type="button"
                        className="manageEventModal__confirmButton cancel"
                        onClick={handleCancelComplete}
                        disabled={isPending ? isPending : false}
                    >
                        {cancelText || "Отмена"}
                    </button>

                    <button
                        type="button"
                        className="manageEventModal__confirmButton submit"
                        onClick={onConfirm}
                        disabled={isPending ? isPending : false}
                    >
                        {isPending ? "Подождите..." : confirmText}
                    </button>
                </div>
            </div>
        </div>
    )
}

export default ConfirmModal